// This file is automatically generated. Do not edit manually.

import { DeliveryPackageSource } from "src/api/generated/erp/delivery/model/deliveryPackageSource";
import { DeliveryPackage } from "src/api/generated/erp/db/types/tables/deliveryPackage";
import { DeliveryPackageType } from "src/api/generated/erp/db/types/tables/deliveryPackageType";
import { WarehouseLocation } from "src/api/generated/erp/db/types/tables/warehouseLocation";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace DeliveryPackageFormApi {
	export async function getInitData(args: {
		source: DeliveryPackageSource | null | undefined;
		deliveryPackageId: number | null | undefined;
		isBundle?: boolean;
	}): Promise<DeliveryPackageFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackageForm/getInitData",
			method: "POST",
			data: {
				source: args.source,
				deliveryPackageId: args.deliveryPackageId,
				isBundle: args.isBundle,
			},
		});
		return response as DeliveryPackageFormApi_InitData;
	}

	export async function insert(args: {
		deliveryPackage: DeliveryPackage;
		connectToDeliveryId?: number | null | undefined;
		bundleChildPackageIds?: Array<number> | null | undefined;
		connectToSources: Array<DeliveryPackageSource>;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackageForm/insert",
			method: "POST",
			data: {
				deliveryPackage: args.deliveryPackage,
				connectToDeliveryId: args.connectToDeliveryId,
				bundleChildPackageIds: args.bundleChildPackageIds,
				connectToSources: args.connectToSources,
			},
		});
		return response as number;
	}

	export async function update(args: { deliveryPackage: DeliveryPackage }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/delivery/deliveryPackageForm/update",
			method: "POST",
			data: {
				deliveryPackage: args.deliveryPackage,
			},
		});
		return response as void;
	}
}

export interface DeliveryPackageFormApi_InitData {
	deliveryPackage: DeliveryPackage | null | undefined;
	nextPackageNumber: number;
	packageTypeOptions: Array<DeliveryPackageType>;
	warehouseLocationOptions: Array<WarehouseLocation>;
}
